







































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FooterComponent from '@/components/footer.component.vue';
import AuthenticationModule from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { mapState } from 'vuex';

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FooterComponent
  },
  computed: {
    ...mapState('authentication', ['showButtonLoading'])
  }
})
export default class ForgotPasswordComponent extends Vue {
  public showButtonLoading: boolean;
  public email = '';

  public $refs: {
    form: HTMLFormElement;
  };

  public created() {
    this.email = '';
  }

  public async onSendClick() {
    const success: boolean = await this.$refs.form.validate();

    if (!success) {
      return;
    }

    // forgot password
    await authenticationModule.forgotPasswordAction({
      email: this.email
    });

    this.$toasted.success(
      'An email has been sent with a link to reset your password. Please check your email to continue.',
      {
        onComplete: () => {
          this.onBackToLoginClick();
        },
        duration: 4000
      }
    );
  }

  public onBackToLoginClick() {
    authenticationModule.changeComponentStateAction(true);
  }
}
